import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { useQuery } from "../../utils/useQuery";
import { ViewExpenseTableAdmin } from "./Salarytable";
const arr = [{ label: "Name", value: "Name" }];
const ViewSalaryExpenseAdmin = () => {
  const query = useQuery();
  const id = query.get("id");

  const { user,setTransactionLoaderState } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const { password , username } = billpunchbasicauth;
 
  
  const getPropertyExpense = async (e) => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: "0",
        firmid:user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmExpense`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    getPropertyExpense();
  }, []);
 
  return (
    <>
      <div>
        <div className=" row mx-0 mt-md-4 mt-sm-4 p-0 mt-sm-3">
          <h5 className="col mx-md-3 mx-sm-3 mb-sm-4 d-flex align-items-center ">
            {" "}
            {user.organisation} Expenses List
          </h5>

          <div className=" col-2 mr-md-4 mr-sm-3 d-flex justify-content-end">
            {" "}
            <Link to={"/admin/expense-management"}>
              <button
                type="button"
                className="btn btn-sm justify-content-center align-items-center"
                style={{
                  background: "#2ca01c",
                  borderRadius: ".4em",
                  height: "2.5em",
                  // width: "8rem",
                  border: "None",
                  color: "#fff",
                }}
              >
                Back
              </button>
            </Link>
          </div>
        </div>

        <div
          className=" p-0 mx-md-3"
          style={{
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
          }}
        >
          <ViewExpenseTableAdmin data={data} getPropertyExpense={getPropertyExpense}/>
        </div>
      </div>
    </>
  );
};

export default ViewSalaryExpenseAdmin;